/** Domaine public de production (liens partagés, inventaire réseaux sociaux). Jamais *.vercel.app. */
export const PUBLIC_SITE_ORIGIN = "https://rdvmarket.fr";

/** Origine publique pour JSON-LD ; surcharger avec REACT_APP_SITE_URL sur le build CI */
export function getCanonicalOrigin() {
  if (typeof window !== "undefined") return window.location.origin;
  return (process.env.REACT_APP_SITE_URL || PUBLIC_SITE_ORIGIN).replace(/\/$/, "");
}

/** Liens dans les messages de diffusion (admin) : toujours rdvmarket.fr */
export function getPublicSiteUrl() {
  const fromEnv = String(process.env.REACT_APP_SITE_URL || "")
    .trim()
    .replace(/\/$/, "");
  if (fromEnv) {
    try {
      const host = new URL(fromEnv).hostname.toLowerCase();
      if (!host.includes("vercel.app") && host.includes("rdvmarket.fr")) return fromEnv;
    } catch {
      /* ignore */
    }
  }
  return PUBLIC_SITE_ORIGIN;
}

export const SITE_NAME = "RdvMarket";

export const SITE_TAGLINE = "Marketplace des rendez-vous qualifiés";

export const DEFAULT_DESCRIPTION =
  "Achetez et vendez des dossiers clients en toute confiance : paiement sous séquestre Stripe, appels anonymisés et enregistrés, analyse des appels par IA, équipe d’arbitrage. L’encaissement vendeur passe par Stripe Connect (IBAN et identité au versement).";

/** Image sociale par défaut (1200×630) — remplacer par un PNG/JPG si besoin (meilleure compat Facebook). */
export const DEFAULT_OG_IMAGE_PATH = "/og-default.svg";
